import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kh-settings-toggle-field',
  templateUrl: './settings-toggle-field.component.html',
  styleUrls: ['./settings-toggle-field.component.less'],
  standalone: false
})
export class SettingsToggleFieldComponent {
  @Input() public title = '';
  @Input() public description = '';
  @Input() public control!: FormControl;
  @Input() public testId = 'switch-checkbox';
  @Output() public isChecked = new EventEmitter<boolean>();
}
